import { useZoomSettingProvider } from './zoom-setting-provider';

export const useLeadProvider = () => {
  const { provide: provideZoomSetting } = useZoomSettingProvider();

  const privide = async () => {
    await provideZoomSetting();
  };

  return {
    privide,
  };
};
